import { Component, OnInit } from '@angular/core';
import { Project } from '../shared/interfaces/project.interface';
import { ProjectGroup } from '../shared/interfaces/project-group.interface';
import { Subscription } from 'rxjs';
import { ProjectDataService } from '../shared/services/project-data.service';
import { ProjectService } from '../shared/services/project.service';
import { AlertService } from 'src/app/shared/alert/shared/alert.service';
import { MatDialog } from '@angular/material/dialog';
import { ImageDataService } from '../shared/services/image-data.service';
import { ScenarioService } from '../shared/services/scenario.service';
import { GroupService } from '../shared/services/group.service';
import { EditUser } from 'src/app/user/shared/interfaces/edit-user.interface';
import { ProjectRouteStation } from '../shared/interfaces/project-route-station.interface';
import { ProjectRouteStationWithParam } from '../shared/interfaces/project-route-station.class';
import { ProjectImageData } from '../shared/interfaces/project-image-data.interface';
import { CameraService } from '../shared/services/camera.service';
import { LoginService } from 'src/app/user/shared/services/login.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Recordings } from '../shared/interfaces/recordings.interface';
import { HttpResponse } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';

@Component({
  selector: 'avs-project-traffic-monitoring',
  standalone: false,
  templateUrl: './project-traffic-monitoring.component.html',
  styleUrl: './project-traffic-monitoring.component.css'
})
export class ProjectTrafficMonitoringComponent implements OnInit {
  public activeProject: Project | undefined;
  public activeGroup: ProjectGroup | undefined;
  public activeProjectsUsers: EditUser[] = [];
  public routeStations: ProjectRouteStation[] = [];

  public subscriptionCollection: Subscription[] = [];
  public activeProjectSubscription?: Subscription;
  public activeGroupSubscription?: Subscription;
  public routeStationsSubscription?: Subscription;
  public projectImagesSubscription?: Subscription;
  private activeProjectsUsersSubscription?: Subscription;
  public projectRouteStationsWithParamSubscription?: Subscription;
  public projectRouteStations: ProjectRouteStationWithParam[] | undefined;
  public images: ProjectImageData[] = [];
  public allImages: ProjectImageData[] = [];
  public selectedLpRecording: any | undefined;
  public selectedDomeRecording: Recordings | undefined;
  public isCurrentUserAllowedToDownload: boolean = false;
  public isDomeLoading: boolean = true;
  public isLpLoading: boolean = true;
  displayMessage: string = 'Lade Aufnahmen...';

  guidCollection: string[] = [];
  lpRecordings: ProjectRouteStationWithParam[] = [];
  domeRecordings: ProjectRouteStationWithParam[] = [];
  public videoUrl?: SafeUrl;

  public domeVideoUrl?: SafeUrl;
  downloading: boolean = false;

  constructor(private projectDataService: ProjectDataService,
    private projectService: ProjectService,
    private alertService: AlertService,
    private dialog: MatDialog,
    private imageDataService: ImageDataService,
    private cameraService: CameraService,
    private groupService: GroupService,
    public auth: LoginService,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {
    this.activeProjectSubscription = this.projectDataService.activeProject.subscribe((project) => {
      this.activeProject = project;
    });
    this.activeGroupSubscription = this.projectDataService.activeGroup.subscribe((group) => {
      if (group !== this.activeGroup)
        this.activeGroup = group;
      if (this.activeGroup !== undefined) {
      }
    });
    this.activeProjectsUsersSubscription = projectDataService.activeProjectsUsers.subscribe(users => {
      this.activeProjectsUsers = users;
    })
    this.routeStationsSubscription = projectDataService.projectsRouteStations.subscribe(routeStations => {
      this.routeStations = routeStations;
    });
    this.projectImagesSubscription = imageDataService.projectImages.subscribe(images => {
      this.images = images;
      this.allImages = images;
    });
    this.projectRouteStationsWithParamSubscription = projectDataService.projectsRouteStationsWithParam.subscribe(routeStations => {
      if (routeStations) { this.getCamerasRecordings(routeStations); }
      this.projectRouteStations = routeStations;
    });
  }

  public ngOnInit(): void {
    this.subscriptionCollection.push(this.activeProjectSubscription!);
    this.subscriptionCollection.push(this.activeGroupSubscription!);
    this.subscriptionCollection.push(this.routeStationsSubscription!);
    this.subscriptionCollection.push(this.projectImagesSubscription!);
    this.subscriptionCollection.push(this.projectRouteStationsWithParamSubscription!);
    this.subscriptionCollection.push(this.activeProjectsUsersSubscription!);
    this.checkUserDownloadPermission();
  }

  public ngOnDestroy(): void {
    this.subscriptionCollection.forEach(subscription => subscription.unsubscribe());
    this.lpRecordings = [];
    this.domeRecordings = [];
    this.guidCollection = [];
    this.isLpLoading = true;
    this.isDomeLoading = true;
  }

  public checkUserDownloadPermission(): void {
    this.auth.getCurrentUser().subscribe(user => {
      if (user && user.isAuthorizedForDownloads) {
        this.isCurrentUserAllowedToDownload = true;
      } else {
        this.isCurrentUserAllowedToDownload = false;
      }
    });
  }

  private getCamerasRecordings(routeStations: ProjectRouteStationWithParam[]): void {
    this.lpRecordings = [];
    this.domeRecordings = [];
    this.guidCollection = [];
    this.isLpLoading = true;
    this.isDomeLoading = true;
    routeStations.forEach(station => {
      const typ = station.schemaInfo?.deviceType;
      if ((typ === 5 || typ === 6) && station.routeStation.id && !this.guidCollection.includes(station.routeStation.id)) {
        this.guidCollection.push(station.routeStation.id);
        this.cameraService.getRecordings(station.routeStation.id)
          .subscribe(recordings => {
            station.recordings = recordings;
            if (typ === 5) {
              this.lpRecordings.push(station);
              station.selectedRecording = this.lpRecordings[0].recordings[0];
              this.isLpLoading = false;
            } else {
              this.domeRecordings.push(station);
              station.selectedRecording = this.domeRecordings[0].recordings[0];
              this.isDomeLoading = false;
            }
          },
            error => {
              console.log('Error fetching recordings for LP camera', error);
              this.isLpLoading = false;
              this.isDomeLoading = false;
              this.displayMessage = 'Fehler beim Laden der Aufnahmen.';
            },
            () => {
              this.isLpLoading = false;
              this.isDomeLoading = false;
            }
          );
      }
    })
    if (this.guidCollection.length === 0) {
      this.isLpLoading = false;
      this.isDomeLoading = false;
      this.displayMessage = 'Keine Kameras mit Aufnahmen gefunden.';
      this.router.navigate(['project/schema']);
    };
  }

  get stationsWithRecordings(): ProjectRouteStationWithParam[] {
    return (this.projectRouteStations ?? []).filter(station =>
      Array.isArray(station.recordings) && station.recordings.length > 0
    );
  }

  public downloadRecording(): void {
    this.cameraService.downloadRecording(this.lpRecordings[0].routeStation.id, this.selectedLpRecording)
      .subscribe(response => {

        let blob: Blob;

        // Check if response is Base64 string
        if (typeof response === 'string') {
          const binaryString = window.atob(response);
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }
          blob = new Blob([bytes], { type: 'video/mp4' });
        } else {
          // Response is Blob already
          blob = response;
        }
        // Create object URL and sanitize it
        const url = window.URL.createObjectURL(blob);
        const safeUrl: SafeUrl = this.sanitizer.bypassSecurityTrustUrl(url);
        // Create anchor element for download
        const a = document.createElement('a');
        a.href = safeUrl as string; // DomSanitizer returns SafeUrl, cast to string for href
        a.download = `recording_${this.selectedLpRecording}.mp4`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        // Release object URL after download
        window.URL.revokeObjectURL(url);
      });
  }

  public onDomeRecordingChange(event: Recordings, station: ProjectRouteStationWithParam): void {
    station.selectedRecording = event;
  }
  compareRecordings(rec1: any, rec2: any): boolean {
    return rec1 && rec2 ? rec1.id === rec2.id : rec1 === rec2;
  }

  public downloadDomeRecording(index: number, rs: ProjectRouteStationWithParam): void {
    const station = this.domeRecordings[index];
    this.cameraService.getRecordingWithMemStream(station.routeStation.id, rs.selectedRecording?.id!)
      .subscribe(response => {
        let blob: Blob;
        // Check if response is Base64 string
        if (typeof response === 'string') {
          const binaryString = window.atob(response);
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }
          blob = new Blob([bytes], { type: 'video/x-matroska' });
        } else {
          // Response is Blob already
          blob = response;
        }
        // Create object URL and sanitize it
        const url = window.URL.createObjectURL(blob);
        this.domeVideoUrl = this.sanitizer.bypassSecurityTrustUrl(url);
        // Create anchor element for download
        const a = document.createElement('a');
        a.href = this.domeVideoUrl as string; // DomSanitizer returns SafeUrl, cast to string for href
        a.download = `recording_${rs.selectedRecording?.id!}.mkv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        // Release object URL after download
        window.URL.revokeObjectURL(url);
      });
  }

  downloadVideo(index: number, rs: ProjectRouteStationWithParam) {
    this.downloading = true;
    this.cameraService.getRecording(rs.routeStation.id, rs.selectedRecording?.id!)
      .subscribe((response: Blob) => {
        const filename = `recording_${rs.selectedRecording?.id!}.mp4`;
        saveAs(response, filename);
        this.downloading = false;
      }, error => {
        this.downloading = false;
      });
  }

  downloadLPVideo(station: ProjectRouteStationWithParam) {
    if (!station.selectedRecording) {
      return;
    }
    if (!station.selectedRecording) {
      return;
    }
    this.cameraService.getRecording(station.routeStation.id, station.selectedRecording.id)
      .subscribe((response: Blob) => {
        const filename = `recording_${station.selectedRecording?.id}.mp4`;
        saveAs(response, filename);
      }, error => {
      });
  }
}
